import { IGoinZoneObject, IZoneObject, IMap } from '../../../types/'
import * as constants from '../../constants/'
import { createAction } from '../helpers'
import { goinzoneService } from 'src/services/Goinzones'
import { actionCreators as serviceActionCreators } from '../services'

export const actionCreators = {
  createGoinzoneRequest: () => createAction(constants.CREATE_GOINZONE_REQUEST),
  createGoinzoneSuccess: () => createAction(constants.CREATE_GOINZONE_SUCCESS),
  createGoinzoneFailure: (error: string) => createAction(constants.CREATE_GOINZONE_FAIL, error),

  getGoinzoneRequest: () => createAction(constants.GET_GOINZONE_REQUEST),
  getGoinzoneSuccess: (data: IMap<IZoneObject>) => createAction(constants.GET_GOINZONE_SUCCESS, data),
  getGoinzoneFailure: (error: string) => createAction(constants.GET_GOINZONE_FAIL, error),

  getGoinzoneByLocationsRequest: () => createAction(constants.GET_GOINZONE_BY_LOCATION_REQUEST),
  setGoinVisiblity: (data: boolean) => createAction(constants.SET_GOINZONE_VISIBLITY, data),
  getGoinzoneByLocationsSuccess: (data: IMap<IZoneObject>) =>
    createAction(constants.GET_GOINZONE_BY_LOCATION_SUCCESS, data),
  getGoinzoneByLocationsFailure: (error: string) => createAction(constants.GET_GOINZONE_BY_LOCATION_FAIL, error),

  removeGoinzoneRequest: () => createAction(constants.REMOVE_GOINZONE_REQUEST),
  removeGoinzoneSuccess: () => createAction(constants.REMOVE_GOINZONE_SUCCESS),
  removeGoinzoneFailure: (error: string) => createAction(constants.REMOVE_GOINZONE_FAIL, error),

  updateGoinzoneRequest: () => createAction(constants.UPDATE_GOINZONE_REQUEST),
  updateGoinzoneSuccess: () => createAction(constants.UPDATE_GOINZONE_SUCCESS),
  updateGoinzoneFailure: (error: string) => createAction(constants.UPDATE_GOINZONE_FAIL, error),
  serviceCreateSetFetching: (fetching: boolean) => createAction(constants.SERVICE_EDIT_SET_FETCHING, fetching)
}

export function getGoinzones(orgId: string, serviceId?: string) {
  const { getGoinzoneRequest, getGoinzoneSuccess, getGoinzoneFailure, serviceCreateSetFetching } = actionCreators
  return (dispatch: any) => {
    dispatch(getGoinzoneRequest())
    dispatch(serviceCreateSetFetching(true))
    return goinzoneService.getGoinzones(orgId, serviceId).then(
      (zones: IZoneObject[]) => {
        const zonesObj: IMap<IZoneObject> = {}
        zones.forEach(z => {
          if (z.id) {
            zonesObj[z.id] = z
          }
        })
        dispatch(getGoinzoneSuccess(zonesObj))
        dispatch(serviceCreateSetFetching(false))
        return
      },
      (error: any) => dispatch(getGoinzoneFailure(error.data))
    )
  }
}

export function setVisible(visible: boolean) {
  const { setGoinVisiblity } = actionCreators
  return (dispatch: any) => {
    dispatch(setGoinVisiblity(visible))
  }
}

export function toggleZone(zones: { [key: string]: IZoneObject } | {}) {
  const { getGoinzoneSuccess } = actionCreators
  return (dispatch: any) => {
    dispatch(getGoinzoneSuccess(zones))
  }
}

export function getAllGoinzones(orgId: string) {
  const { getGoinzoneRequest, getGoinzoneSuccess, getGoinzoneFailure } = actionCreators
  return (dispatch: any) => {
    dispatch(getGoinzoneRequest())
    return goinzoneService.getAllGoinzones(orgId).then(
      (zones: IZoneObject[]) => {
        const zonesObj: IMap<IZoneObject> = {}
        zones.forEach(z => {
          if (z.id) {
            zonesObj[z.id] = z
          }
        })
        dispatch(getGoinzoneSuccess(zonesObj))
        return
      },
      (error: any) => dispatch(getGoinzoneFailure(error.data))
    )
  }
}

export function getGoinzonesByLocations(locations: Array<{ lat: number; lng: number }>) {
  const { getGoinzoneByLocationsRequest, getGoinzoneByLocationsSuccess, getGoinzoneByLocationsFailure } = actionCreators
  return (dispatch: any) => {
    dispatch(getGoinzoneByLocationsRequest())
    return goinzoneService.getGoinzonesByLocations(locations).then(
      (zones: IZoneObject[]) => {
        const zonesObj: IMap<IZoneObject> = {}
        zones.forEach(z => {
          if (z.id) {
            zonesObj[z.id] = z
          }
        })
        dispatch(getGoinzoneByLocationsSuccess(zonesObj))
        return
      },
      (error: any) => dispatch(getGoinzoneByLocationsFailure(error.data))
    )
  }
}

export function createGoinzones(goinzone: IZoneObject, orgId: string, serviceId: string) {
  const { createGoinzoneRequest, createGoinzoneSuccess, createGoinzoneFailure } = actionCreators
  return (dispatch: any) => {
    dispatch(createGoinzoneRequest())
    return goinzoneService.createGoinzone(goinzone, orgId, serviceId).then(
      () => {
        dispatch(createGoinzoneSuccess())
        dispatch(serviceActionCreators.serviceCreateSetStepCompleted(3, true))
        return
      },
      (error: any) => dispatch(createGoinzoneFailure(error.data))
    )
  }
}

export function createServiceZoneHotspot(goinzone: IZoneObject, orgId: string, serviceId: string) {
  const { createGoinzoneRequest, createGoinzoneSuccess, createGoinzoneFailure } = actionCreators
  return (dispatch: any) => {
    dispatch(createGoinzoneRequest())
    return goinzoneService.createServiceZoneHotspot(goinzone, orgId, serviceId).then(
      () => {
        dispatch(createGoinzoneSuccess())
        dispatch(serviceActionCreators.serviceCreateSetStepCompleted(3, true))
        return
      },
      (error: any) => dispatch(createGoinzoneFailure(error.data))
    )
  }
}

export function removeGoinzone(id: string) {
  const { removeGoinzoneRequest, removeGoinzoneSuccess, removeGoinzoneFailure } = actionCreators
  return (dispatch: any) => {
    dispatch(removeGoinzoneRequest())
    return goinzoneService.removeGoinzone(id).then(
      () => {
        dispatch(removeGoinzoneSuccess())
        return
      },
      (error: any) => dispatch(removeGoinzoneFailure(error.data))
    )
  }
}

export function updateGoinzone(goinzone: IZoneObject, orgId: string, serviceId: string) {
  const { updateGoinzoneRequest, updateGoinzoneSuccess, updateGoinzoneFailure } = actionCreators
  return (dispatch: any) => {
    dispatch(updateGoinzoneRequest())
    return goinzoneService.updateGoinzone(goinzone, orgId, serviceId).then(
      () => {
        dispatch(updateGoinzoneSuccess())
        return
      },
      (error: any) => dispatch(updateGoinzoneFailure(error.data))
    )
  }
}

export function enableButtons(flag: boolean) {
  const { serviceCreateSetFetching } = actionCreators
  return (dispatch: any) => {
    dispatch(serviceCreateSetFetching(flag))
  }
}



// WEBPACK FOOTER //
// ./src/state/actions/goinzones/index.ts